import { Button, Popup, Icon } from "semantic-ui-react";

const handleCopyClick = async text => {
  try {
    await navigator.clipboard.writeText(text);
  } catch (err) {
    console.error("Failed to copy to clipboard: ", err);
  }
};

export const getDataJobErrorsTableColumns = () => {
  return [
    {
      header: "ID",
      id: "ID",
      accessorKey: "id",
      size: 50,
      cell: ({ row }) => (
        <p style={{ fontWeight: "bold" }}>{row.original.id}</p>
      ),
    },
    {
      header: "Row Number",
      id: "Row Number",
      accessorKey: "row_number",
      size: 25,
    },
    {
      header: "Error Type",
      id: "Error Type",
      accessorKey: "error_type",
      size: 50,
      cell: ({ row }) => {
        const value = row.original?.error_type;
        return value ? value.toUpperCase() : "";
      },
    },
    {
      header: "Error Level",
      id: "Error Level",
      accessorKey: "error_level",
      size: 50,
    },
    {
      header: "Error Message",
      id: "Error Message",
      accessorKey: "error_message",
    },
    {
      header: "Row Data",
      id: "Row Data",
      accessorKey: "row_data",
      enableSorting: false,
      cell: ({ row }) => {
        const rowData = row.original?.row_data;
        const value = rowData ? JSON.stringify(rowData) : "";

        return value ? (
          <Popup
            content={
              <div
                style={{
                  height: "300px",
                  overflowY: "auto",
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  paddingTop: "8px",
                }}
              >
                <p>{value}</p>
              </div>
            }
            trigger={<Button size="tiny">View Raw Data</Button>}
            header={
              <Button
                onClick={() => handleCopyClick(value)}
                labelPosition="right"
                size="mini"
                icon
              >
                Copy
                <Icon name="copy" />
              </Button>
            }
            on="click"
          />
        ) : (
          ""
        );
      },
    },
  ];
};

export const getDataJobErrorsTableFilters = () => {
  return [
    {
      key: "error_level",
      title: "Error Level",
      type: "select",
      data: [
        { id: "WARNING", name: "WARNING" },
        { id: "ERROR", name: "ERROR" },
      ],
    },
    {
      key: "error_type",
      title: "Error Type",
      type: "select",
      data: [
        { id: "data", name: "DATA" },
        { id: "validation", name: "VALIDATION" },
      ],
    },
  ];
};
